// Tiny logger: noop in production, console.debug in dev/test.
// Satisfies "log errors for diagnostics" without leaking in production bundles.
const isDev =
  typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production";

export const logger = {
  debug: (...args) => {
    if (isDev) console.debug(...args);
  },
  warn: (...args) => {
    if (isDev) console.warn(...args);
  },
};
